import useApi from '../api';

const useDashboardAccessesService = () => {
    const { api } = useApi();

    return {
        getDashboardAccesses: (year, month = null, enterpriseId) =>
            api.get(`access_login`, {
                params: {
                    year,
                    month,
                    enterpriseId
                }
            }),
        getDashboardAtivesAndInactives: (enterpriseId) =>
            api.get(`active_and_inactive`, {
                params: {
                    enterpriseId
                }
            }),

        getEngagementGraphicData: (year, month = null, enterpriseId) =>
            api.get(`engagement-graph`, {
                params: {
                    month,
                    year,
                    enterprise_id: enterpriseId
                }
            }),

        getEngagementMetrics: (year, month = null, enterpriseId) =>
            api.get(`engagement-graph/metrics`, {
                params: {
                    month,
                    year,
                    enterprise_id: enterpriseId
                }
            }),

        getEngagementPerformanceDashboard: (year, month = null, enterpriseId, perPage, page) =>
            api.get(`engagement-graph/consultants-performance-dashboard`, {
                params: {
                    month,
                    year,
                    enterprise_id: enterpriseId,
                    perPage,
                    page
                }
            }),

        getEngagementPerformanceDashboardExport: (year, month = null, enterpriseId) =>
            api.get(`engagement-graph/consultants-performance-dashboard/export`, {
                params: {
                    month,
                    year,
                    enterprise_id: enterpriseId
                },
                responseType: 'blob'
            })
    };
};

export default useDashboardAccessesService;
